// A session by the exact name its app shows it under (Round 6, 21 Oct): T3 Code's thread title, Claude Code's session
// name, Codex's thread name. Only when its app gives none does the board make one up, and it reads as a stand-in.

export const sessionName = (x: { title?: string | null; project?: string | null }): string => x.title?.trim() || `Untitled session${x.project ? ` in ${x.project}` : ""}`;
